<template>
  <loader-wrapper
    :loading="loading"
    spinner="el-icon-loading"
    @click.native="openAct"
  >
    <el-row v-if="act" :class="['flight-act', actInfo.status]">
      <el-badge :class="actInfo.isBadge ? 'act-badge' : ''">
        {{ actInfo.text }}
      </el-badge>
    </el-row>
    <div v-else class="flight-act danger">АКТ</div>
  </loader-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'FlightAct',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      getFlights: 'responses/getFlights',
      getLoading: 'responses/getLoading',
    }),
    loading() {
      return this.getLoading('Act')
    },
    act() {
      const acts = this.getFlights(this.id, 'Act')

      return acts.find(c => c.files.length) || acts[0]
    },
    actInfo() {
      if (!this.act) {
        return ''
      }
      const { number, document_create_date, files, pc_api_transactions } =
        this.act
      const day = this.dateToFormat(
        document_create_date,
        'shortDateWithoutYear',
      )
      const text = `АКТ ${number || '-'} от ${day || '-'}`
      const isBadge = pc_api_transactions && Boolean(pc_api_transactions.length)
      let status = 'danger'

      if (number && document_create_date && files.length) {
        status = 'success'
      } else if (number && document_create_date && !files.length) {
        status = 'warning'
      }

      return { text, status, isBadge }
    },
  },
  methods: {
    openAct() {
      if (!this.loading) {
        this.$emit('act')
      }
    },
  },
}
</script>

<style lang="sass">
.flight-item
  .flight-act
    font-weight: bold
    position: relative
    text-align: center
    &.danger
      color: #f00
    &.warning
      color: #ffb800
    &.success
      color: #00bf40
    .act-badge
      &:after
        content: ''
        position: absolute
        background: url('~@/assets/img/sign-badge.png')
        width: 13px;
        height: 15px;
        top: -10px;
        right: -10px;
        background-size: cover;
</style>
